import React, { useEffect, useState } from "react";
import Table from "../../../Utils/Table/Table1";
import { getFundstatus } from "../../../Services/Admin/Addmin";
import {
  UpdatestatusForpaymenthistory,
  InrUpdatestatusForpaymenthistory,
} from "../../../Services/Admin/Addmin";
import Swal from "sweetalert2";
import { fDateTime } from "../../../Utils/Date_format/datefromat";
import Modal from "react-modal";
import { getUserFromToken } from "../../../Utils/TokenVerify";
import { getAllClient } from "../../../Services/Superadmin/Superadmin";
import { useLocation } from "react-router-dom";

const Withdraw = () => {

  const state = useLocation()


  const [data, setData] = useState([]);
  const TokenData = getUserFromToken();
  const user_id = TokenData?.user_id;

  const [activeTab, setActiveTab] = useState("Pending");
  const [selectedValues, setSelectedValues] = useState({});
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedBankDetails, setSelectedBankDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeWallet, setActiveWallet] = useState(state?.state?.item === "rupee" ? "INR" : "USD");
    const decimalPoint = activeWallet === "INR" ? 2 : 3;


  const handleOpenModal = (data) => {
    setSelectedBankDetails(data);
    setShowModal(true);
  };



  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedBankDetails(null);
  };



  const [showCompleteModal, setShowCompleteModal] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const [uploadedImage, setUploadedImage] = useState(null);
  const [currentRowId, setCurrentRowId] = useState(null);
  const [client, setClient] = useState([]);



  useEffect(() => {
    getallclient();
  }, []);



  useEffect(() => {
    getAllfundsstatus();
  }, [search, activeTab, page, rowsPerPage, activeWallet]);



  const handleSelectChange = async (rowId, row, event) => {
    const newSelectedValues = {
      ...selectedValues,
      [rowId]: event.target.value,
    };
    setSelectedValues(newSelectedValues);

    if (event.target.value === "1") {
      setCurrentRowId(row._id);
      setShowCompleteModal(true);
    } else {
      await Updatestatus(row._id, newSelectedValues[rowId], row);
    }
  };




  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setUploadedImage(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };



  const handleComplete = async () => {
    if (!transactionId || !uploadedImage) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please provide both Transaction ID and Screenshot.",
        timer: 2000,
      });
      return;
    }

    const status = "1";
    const data = {
      admin_id: user_id,
      id: currentRowId,
      status,
      transactionId,
      screenshot: uploadedImage,
      type: "CREDIT",
      //  Balance: row.Balance
    };

    try {
      let response;
      if (activeWallet === "INR") {
        response = await InrUpdatestatusForpaymenthistory(data);
      } else {
        response = await UpdatestatusForpaymenthistory(data);
      }

      if (response.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.message || "Request marked as complete.",
          timer: 2000,
        });
        setShowCompleteModal(false);
        setTransactionId("");
        setUploadedImage(null);
        getAllfundsstatus();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.message || "Failed to update the request.",
          timer: 2000,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "An unexpected error occurred.",
        timer: 2000,
      });
    }
  };

  const handleCancel = () => {
    setShowCompleteModal(false);
    setTransactionId("");
    setUploadedImage(null);
  };

  // const columns = [
  //   { Header: "Name", accessor: "FullName" },
  //   {
  //     Header: "Request",
  //     accessor: "type",
  //     Cell: ({ cell }) => (cell.row.type == 0 ? "Withdrawal" : cell),
  //   },
  //   {
  //     Header: "Balance", accessor: "Balance", Cell: ({ cell }) => (
  //       <span>
  //         {activeWallet === "USD" ? "$" : "₹"}{cell.value}
  //       </span>
  //     ),
  //   },


  //   {
  //     Header: "Date",
  //     accessor: "createdAt",
  //     Cell: ({ cell }) => fDateTime(cell.value),
  //   },
  //   {
  //     Header: "Bank Details",
  //     accessor: "bankDetails",
  //     Cell: ({ cell }) => (
  //       <button
  //         onClick={() => handleOpenModal(cell.row)}
  //         className="btn btn-primary btn-sm d-flex align-items-center"
  //       >
  //         <i className="bi bi-eye me-2"></i> View Bank Details
  //       </button>
  //     ),
  //   },
  // ];

  const columns = [
    {
      Header: "Name",
      accessor: "FullName",
    },

    {
      Header: "Request",
      accessor: "type",
      Cell: ({ row }) => (row.type == 0 ? "Withdrawal" : "Deposit"),
    },

    {
      Header: "Balance",
      accessor: "Balance",
      Cell: ({ row }) => (
        <span>
          {activeWallet === "USD" ? "$" : "₹"}{row.Balance.toFixed(decimalPoint)}
        </span>
      ),
    },

    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ row }) => {
        const value = row.createdAt;

        if (!value) return "N/A";

        const dateValue = new Date(value);
        if (isNaN(dateValue)) return "N/A";

        return fDateTime(value);
      },
    },

    {
      Header: "Bank Details",
      accessor: "bankDetails",
      Cell: ({ row }) => (
        <button
          onClick={() => handleOpenModal(row)}
          className="btn btn-primary btn-sm d-flex align-items-center"
        >
          <i className="bi bi-eye me-2"></i> View Bank Details
        </button>
      ),
    },
  ];


  if (activeTab === "Pending" && client.Fund_request == 1) {
    columns.push({
      Header: "Action",
      accessor: "Action",
      Cell: ({ row }) => {
        const item = row;

        return (
          <select
            className="form-select"
            value={selectedValues[item._id] || "0"}
            onChange={(event) =>
              handleSelectChange(item._id, item, event)
            }
          >
            <option value="0">Pending</option>
            <option value="2">Reject</option>
            <option value="1">Complete</option>
          </select>
        );
      },
    });
  }


  const Updatestatus = async (id, status, row) => {
    try {
      const admin_id = user_id;
      const data = { admin_id, id, status, type: "DEBIT", Balance: row.Balance };
      let response;
      if (activeWallet === "INR") {
        response = await InrUpdatestatusForpaymenthistory(data);
      } else {
        response = await UpdatestatusForpaymenthistory(data);
      }

      if (response.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text:
            response.message ||
            "An unexpected error occurred. Please try again.",
          timer: 2000,
        });
        getAllfundsstatus();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            response.message ||
            "Failed to update the request. Please try again.",
          timer: 2000,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.message || "An unexpected error occurred. Please try again.",
        timer: 2000,
      });
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const getAllfundsstatus = async () => {
    try {
      setLoading(true);
      const data = {
        adminid: user_id,
        type: 0,
        activeTab,
        page,
        limit: rowsPerPage,
        market: activeWallet,
        search: search
      };
      let response = await getFundstatus(data);
      if (response.status) {
        setData(response.data || []);

        setTotalPages(response?.pagination?.totalPages || 0);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage < 1) return;
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newLimit) => {
    setRowsPerPage(newLimit);
    setPage(1); // reset page when limit changes
  };

  const getallclient = async () => {
    try {
      const data = { userid: user_id };
      const response = await getAllClient(data);
      if (response.status) {
        setClient(response.data);
      }
    } catch (error) { }
  };

  const filterDataByStatus = (status) => {
    return data.filter((item) => item.status === status);
  };

  const renderTable = (status) => {
    return (
      <div className="table-responsive shadow-lg">
        <div className="mb-3 ms-4 mt-2">
          <label className="form-label">🔍 Search:</label>
          <input
            className=" input-search form-control"
            style={{ width: "30%" }}
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value)
              setPage(1);
            }}
          />
        </div>
        <h5 className="ms-4 my-4 ">{activeTab} Transactions</h5>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "300px",
            }}
          >
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <Table
              columns={columns}
              data={data}
              page={page}
              totalPages={totalPages}
              initialRowsPerPage={rowsPerPage}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
            />
            <div
              className="d-flex justify-content-between align-items-center px-3 py-2"
              style={{ marginBottom: "20px" }}
            >
              {/* Rows per page */}
              {/* <div className="d-flex align-items-center">
                <span>Rows per page:</span>
                <select
                  className="form-select ms-2"
                  value={rowsPerPage}
                  onChange={(e) => setRowsPerPage(Number(e.target.value))}
                  style={{ width: "auto" }}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div> */}

              {/* Pagination controls */}
              {/* <div className="d-flex justify-content-end align-items-center mt-3 w-100 gap-2">

                <button
                  className="btn btn-outline-primary d-flex align-items-center gap-2"
                  onClick={() => handlePageChange(page - 1)}
                  disabled={page === 1}
                >
                  <i className="bi bi-chevron-left"></i>
                  <span>Prev</span>
                </button>
                <span className="fw-semibold text-secondary ">
                  Page {page} of {totalCount}
                </span>
                <button
                  className="btn btn-outline-primary  d-flex align-items-center gap-2"
                  onClick={() => handlePageChange(page + 1)}
                  disabled={page >= totalCount}
                >
                  <span>Next</span>
                  <i className="bi bi-chevron-right"></i>
                </button>
              </div> */}
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <div>
      <div className="row">
        <div className="demo-view">
          <div className="container-fluid mt-5" >
            <div className="row ">
              <div className="col-xl-12 ">
                <div className="card dz-card " id="nav-pills">
                  <div className="card-header flex-wrap border-0">
                    <h4 className="card-title py-1">Withdrawal History</h4>
                    {/* Wallet Type Tabs */}
                    <div className="wallet-tabs">
                      <div className="btn-group " role="group">
                        {TokenData?.market.includes(0) && (
                          <button
                            type="button"
                            className={`btn ${activeWallet === "USD"
                              ? "btn-primary"
                              : "btn-outline-primary"
                              }`}
                            onClick={() => setActiveWallet("USD")}
                          >
                            <i className="fas fa-dollar-sign me-2"></i>
                            USD Wallet
                          </button>
                        )}
                        {TokenData?.market.includes(1) && (
                          <button
                            type="button"
                            className={`btn ${activeWallet === "INR"
                              ? "btn-primary"
                              : "btn-outline-primary"
                              }`}
                            onClick={() => setActiveWallet("INR")}
                          >
                            <i className="fas fa-rupee-sign me-2"></i>
                            INR Wallet
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="tab-content" id="myTabContent3">
                    <div
                      className="tab-pane fade show active"
                      id="NavPills"
                      role="tabpanel"
                      aria-labelledby="home-tab3"
                    >
                      <div className="card-body ">
                        {/* <ul className="nav nav-pills nav-pills1 mb-4 light">
                          <li className="nav-item">
                            <a
                              href="#navpills-1"
                              className={`nav-link navlink ${activeTab === "Pending" ? "active" : ""
                                }`}
                              data-bs-toggle="tab"
                              aria-expanded="false"
                              onClick={() => handleTabClick("Pending")}
                            >
                              Pending
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              href="#navpills-2"
                              className={`nav-link navlink ${activeTab === "Complete" ? "active" : ""
                                }`}
                              data-bs-toggle="tab"
                              aria-expanded="false"
                              onClick={() => handleTabClick("Complete")}
                            >
                              Complete
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              href="#navpills-3"
                              className={`nav-link navlink ${activeTab === "Reject" ? "active" : ""
                                }`}
                              data-bs-toggle="tab"
                              aria-expanded="true"
                              onClick={() => handleTabClick("Reject")}
                            >
                              Reject
                            </a>
                          </li>
                        </ul> */}
                        {/* 
     <ul className="nav nav-pills nav-pills1 mb-4 light">
  {["Pending", "Complete", "Reject"].map((tab, index) => (
    <li className="nav-item w-100" key={tab}>
      <button
        className={`nav-link seg-pill ${activeTab === tab ? "active" : ""}`}
        onClick={() => handleTabClick(tab)}
      >
        {tab}
      </button>
    </li>
  ))}
</ul> */}

                        <ul className="seg-tabs w-full ">
                          {["Pending", "Complete", "Reject"].map((tab) => (
                            <li className="w-100" key={tab}>
                              <button
                                className={`seg-item w-100  border-0 ${activeTab === tab ? "active" : ""}`}
                                onClick={() => handleTabClick(tab)}
                              >
                                {tab}
                              </button>
                            </li>
                          ))}
                        </ul>



                        <div className="tab-content ">
                          <div
                            id="navpills-1"
                            className={`tab-pane ${activeTab === "Pending" ? "active" : ""
                              }`}
                          >
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="card transaction-table">
                                  <div className="card-body p-0">
                                    <div
                                      className="tab-content"
                                      id="myTabContent1"
                                    >
                                      <div
                                        className="tab-pane fade show active"
                                        id="Week"
                                        role="tabpanel"
                                        aria-labelledby="Week-tab"
                                      >
                                        {renderTable(0)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            id="navpills-2"
                            className={`tab-pane ${activeTab === "Complete" ? "active" : ""
                              }`}
                          >
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="card transaction-table ">
                                  <div className="card-body p-0">
                                    <div
                                      className="tab-content"
                                      id="myTabContent1"
                                    >
                                      <div
                                        className="tab-pane fade show active"
                                        id="Week"
                                        role="tabpanel"
                                        aria-labelledby="Week-tab"
                                      >
                                        {renderTable(1)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            id="navpills-3"
                            className={`tab-pane ${activeTab === "Reject" ? "active" : ""
                              }`}
                          >
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="card transaction-table">
                                  <div className="card-body p-0">
                                    <div
                                      className="tab-content"
                                      id="myTabContent1"
                                    >
                                      <div
                                        className="tab-pane fade show active"
                                        id="Week"
                                        role="tabpanel"
                                        aria-labelledby="Week-tab"
                                      >
                                        {renderTable(2)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={showModal}
        onRequestClose={handleCloseModal}
        contentLabel="Bank Details"
        // style={{
        //   content: {
        //     top: "50%",
        //     left: "50%",
        //     right: "auto",
        //     bottom: "auto",
        //     marginRight: "-50%",
        //     transform: "translate(-50%, -50%)",
        //     width: "500px",
        //     padding: "20px",
        //     borderRadius: "10px",
        //     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        //   },
        //   overlay: {
        //     backgroundColor: "rgba(0, 0, 0, 0.5)",
        //   },
        // }}
        overlayClassName="withdraw-bank-overlay-x71"
        className="withdraw-bank-modal-x71"
      >
        <h4 className="text-center mb-4 fw-bold ">Bank Details</h4>
        {selectedBankDetails && (
          <div>
            <p>
              <strong>Account Holder Name:</strong>{" "}
              {selectedBankDetails.accountHolderName || "N/A"}
            </p>
            <p>
              <strong>Bank Account No:</strong>{" "}
              {selectedBankDetails.bankAccountNo || "N/A"}
            </p>
            <p>
              <strong>Bank IFSC:</strong>{" "}
              {selectedBankDetails.bankIfsc || "N/A"}
            </p>
            <p>
              <strong>Bank Name:</strong>{" "}
              {selectedBankDetails.bankName || "N/A"}
            </p>
            <p>
              <strong>UPI ID:</strong> {selectedBankDetails.upiId || "N/A"}
            </p>
          </div>
        )}
        <div className="text-end mt-4">
          <button onClick={handleCloseModal} className="btn btn-danger">
            Close
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={showCompleteModal}
        onRequestClose={handleCancel}
        contentLabel="Complete Transaction"
        // style={{
        //   content: {
        //     top: "50%",
        //     left: "50%",
        //     right: "auto",
        //     bottom: "auto",
        //     marginRight: "-50%",
        //     transform: "translate(-50%, -50%)",
        //     width: "500px",
        //     padding: "20px",
        //     borderRadius: "10px",
        //     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        //   },
        //   overlay: {
        //     backgroundColor: "rgba(0, 0, 0, 0.5)",
        //   },
        // }}
        overlayClassName="withdraw-bank-overlay-x71"
        className="withdraw-bank-modal-x71"
      >
        <h4 className="text-center fw-bold  mb-4">Complete Transaction</h4>
        <div>
          <div className="mb-3">
            <label htmlFor="transactionId" className="form-label">
              Transaction ID
            </label>
            <input
              type="text"
              id="transactionId"
              className="form-control"
              value={transactionId}
              onChange={(e) => setTransactionId(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="screenshot" className="form-label">
              Upload Screenshot
            </label>
            <input
              type="file"
              id="screenshot"
              className="form-control"
              accept="image/*"
              onChange={handleImageUpload}
            />
          </div>
        </div>
        <div className="text-end mt-4">
          <button onClick={handleComplete} className="btn btn-success me-3">
            Mark Complete
          </button>
          <button onClick={handleCancel} className="btn btn-danger">
            Cancel
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default Withdraw;
